import React from "react";
import { Wheat, Utensils, Sun, Sprout, Egg } from "lucide-react";

const CATEGORIES = [
  {
    icon: Wheat,
    label: "Semolina",
    sub: "Durum wheat semolina sourcing & tenders",
    color: "amber",
  },
  {
    icon: Utensils,
    label: "Spaghetti",
    sub: "Pasta-grade long spaghetti contracts",
    color: "blue",
  },
  {
    icon: Sun,
    label: "Sunflower",
    sub: "Sunflower oil & seed procurement",
    color: "red",
  },
  {
    icon: Sprout,
    label: "Bulgur",
    sub: "Cracked wheat & bulgur supply",
    color: "slate",
  },
  {
    icon: Egg,
    label: "Fresh egg",
    sub: "Table & industrial-grade fresh eggs",
    color: "green",
  },
];

const COLOR_MAP = {
  amber: "bg-amber-50 text-amber-600 group-hover:bg-amber-500",
  slate: "bg-slate-100 text-slate-700 group-hover:bg-slate-800",
  red: "bg-red-50 text-red-500 group-hover:bg-red-500",
  green: "bg-green-50 text-green-600 group-hover:bg-green-500",
  purple: "bg-purple-50 text-purple-600 group-hover:bg-purple-500",
  blue: "bg-blue-50 text-blue-600 group-hover:bg-blue-600",
};

export default function Categories() {
  return (
    <section
      data-testid="categories-section"
      className="relative py-20 md:py-28 bg-slate-50/60"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mx-auto text-center lg:text-left lg:max-w-none reveal mb-12">
          <p className="text-xs font-bold text-blue-600 uppercase tracking-widest mb-3">
            What you can trade
          </p>
          <h2
            data-testid="categories-title"
            className="font-display font-black text-3xl md:text-5xl text-slate-900 leading-tight tracking-tight"
          >
            Product Categories
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {CATEGORIES.map((c, i) => {
            const Icon = c.icon;
            const testId =
              typeof c.label === "string"
                ? c.label.toLowerCase().replace(/\s+/g, "-").replace(/\./g, "")
                : i;
            return (
              <div
                key={c.label}
                data-testid={`category-card-${testId}`}
                className="reveal group text-left bg-white rounded-2xl p-5 md:p-6 border border-slate-200/70 hover:border-blue-300 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
                style={{ transitionDelay: `${i * 40}ms` }}
              >
                <div
                  className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 transition-colors duration-300 ${COLOR_MAP[c.color]} group-hover:text-white`}
                >
                  <Icon size={20} strokeWidth={2.2} />
                </div>
                <h3 className="font-display font-extrabold text-base text-slate-900">
                  {c.label}
                </h3>
                <p className="text-xs text-slate-500 mt-1 font-medium leading-relaxed">
                  {c.sub}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
